import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-f5e1a950"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "title_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Confirmed list", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.83398 15.5C2.37565 15.5 1.98329 15.3368 1.6569 15.0104C1.33051 14.684 1.16732 14.2917 1.16732 13.8333V3H0.333984V1.33333H4.50065V0.5H9.50065V1.33333H13.6673V3H12.834V13.8333C12.834 14.2917 12.6708 14.684 12.3444 15.0104C12.018 15.3368 11.6257 15.5 11.1673 15.5H2.83398ZM4.50065 12.1667H6.16732V4.66667H4.50065V12.1667ZM7.83398 12.1667H9.50065V4.66667H7.83398V12.1667Z",
    fill: "#FF4646"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "table_box" }
const _hoisted_7 = { style: {"width":"200px"} }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f5e1a950><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-f5e1a950><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-f5e1a950></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-f5e1a950><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-f5e1a950></path></g></svg>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "File name", -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div style=\"width:170px;\" data-v-f5e1a950><h3 data-v-f5e1a950>Patient ID</h3></div><div style=\"width:170px;\" data-v-f5e1a950><h3 data-v-f5e1a950>Patient Name</h3></div><div style=\"width:112px;\" data-v-f5e1a950><h3 data-v-f5e1a950>Study Date</h3></div><div style=\"width:67px;\" data-v-f5e1a950><h3 data-v-f5e1a950>Score</h3></div><div style=\"width:120px;\" data-v-f5e1a950><h3 data-v-f5e1a950>Reading time(s)</h3></div>", 5)
const _hoisted_16 = { style: {"width":"200px"} }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f5e1a950><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-f5e1a950><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-f5e1a950></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-f5e1a950><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-f5e1a950></path></g></svg>", 1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "file_name_box" }
const _hoisted_21 = ["onMouseover", "onMouseleave"]
const _hoisted_22 = { style: {"width":"170px"} }
const _hoisted_23 = ["onMouseover", "onMouseleave"]
const _hoisted_24 = { style: {"width":"172px"} }
const _hoisted_25 = ["onMouseover", "onMouseleave"]
const _hoisted_26 = { style: {"width":"112px"} }
const _hoisted_27 = ["onMouseover", "onMouseleave"]
const _hoisted_28 = { style: {"width":"67px"} }
const _hoisted_29 = { style: {"width":"120px"} }
const _hoisted_30 = {
  key: 1,
  class: "no_result_box"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No confirmed list", -1))
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["popup_box contents__box", { 'scroll': _ctx.readingResultList.length > 8}])
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "close_icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePopup()))
      }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass(["delete_btn", {'inactive': _ctx.selectedListCount==0}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteList()))
        }, _hoisted_5, 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["table_header", {active: _ctx.checkAll}])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "checkbox",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAllList(!_ctx.checkAll)))
            }, _hoisted_9),
            _hoisted_10
          ]),
          _hoisted_11
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["table_body my-scroll", {scrollable: _ctx.readingResultList.length>7}])
        }, [
          (_ctx.readingResultList.length>0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.readingResultList, (list) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: list.unique_filename,
                  class: _normalizeClass(["table_tr", {active: list.selected}])
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: "checkbox",
                      onClick: ($event: any) => (_ctx.selectList(list))
                    }, _hoisted_19, 8, _hoisted_17),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("h3", {
                        class: "text-ellipsis",
                        onMouseover: (e) => _ctx.handleMouseEnterFileName(e, list),
                        onMouseleave: ($event: any) => (_ctx.handleMouseLeaveFileName(list))
                      }, _toDisplayString(list.origin_filename), 41, _hoisted_21),
                      _createElementVNode("div", {
                        class: _normalizeClass([{show: list.showFileNameTooltip}, "tooltip"])
                      }, _toDisplayString(list.origin_filename), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("h3", {
                      class: "text-ellipsis",
                      onMouseover: (e) => _ctx.handleMouseEnterId(e, list),
                      onMouseleave: ($event: any) => (_ctx.handleMouseLeaveId(list))
                    }, _toDisplayString(list.patient_id), 41, _hoisted_23),
                    _createElementVNode("div", {
                      class: _normalizeClass([{show: list.showIdTooltip}, "tooltip"])
                    }, _toDisplayString(list.patient_id), 3)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("h3", {
                      class: "text-ellipsis",
                      onMouseover: (e) => _ctx.handleMouseEnterName(e, list),
                      onMouseleave: ($event: any) => (_ctx.handleMouseLeaveName(list))
                    }, _toDisplayString(list.patient_name), 41, _hoisted_25),
                    _createElementVNode("div", {
                      class: _normalizeClass([{show: list.showNameTooltip}, "tooltip"])
                    }, _toDisplayString(list.patient_name), 3)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("h3", {
                      class: "text-ellipsis",
                      onMouseover: (e) => _ctx.handleMouseEnterDate(e, list),
                      onMouseleave: ($event: any) => (_ctx.handleMouseLeaveDate(list))
                    }, _toDisplayString(_ctx.formatStudyDate(list.study_date)), 41, _hoisted_27),
                    _createElementVNode("div", {
                      class: _normalizeClass([{show: list.showDateTooltip}, "tooltip"])
                    }, _toDisplayString(_ctx.formatStudyDate(list.study_date)), 3)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("h3", null, _toDisplayString(list.score), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("h3", null, _toDisplayString(list.reading_time), 1)
                  ])
                ], 2))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
        ], 2)
      ])
    ], 2)
  ]))
}